(function () {
  'use strict';

  /* @ngdoc object
   * @name people.view
   * @description
   *
   */
  angular
    .module('people.view', [
      'ui.router'
    ]);
}());
